module.exports = require("mammoth");